import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Send, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      backgroundColor: 'var(--black)',
      color: 'var(--soft-gray)',
      paddingTop: 'var(--space-xxxl)',
      paddingBottom: 'var(--space-xl)',
      borderTop: '1px solid var(--charcoal)'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 var(--space-xl)'
      }}>
        {/* Main Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 'var(--space-xxxl)',
          marginBottom: 'var(--space-xxxl)'
        }}>
          {/* Brand */}
          <div>
            <h3 style={{
              fontFamily: 'var(--font-display)',
              fontSize: '1.75rem',
              color: 'var(--white)',
              marginBottom: 'var(--space-l)',
              letterSpacing: '-0.02em',
              fontWeight: 300
            }}>
              Наталья Ромашова
            </h3>
            <p style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.875rem',
              color: 'var(--light-gray)',
              lineHeight: '1.8',
              marginBottom: 'var(--space-xl)',
              fontWeight: 300
            }}>
              Консультант по стилю в Санкт-Петербурге.<br/>
              Создаю образы, в которых вы будете чувствовать себя уверенно.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.75rem',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              marginBottom: 'var(--space-l)',
              fontWeight: 500,
              color: 'var(--white)'
            }}>
              Навигация
            </h4>
            <nav style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--space-m)'
            }}>
              {[
                { to: '/', label: 'Главная' },
                { to: '/services', label: 'Услуги' },
                { to: '/cases', label: 'Кейсы' },
                { to: '/about', label: 'О стилисте' },
                { to: '/privacy', label: 'Политика конфиденциальности' }
              ].map((link) => (
                <Link 
                  key={link.to}
                  to={link.to} 
                  style={{
                    color: 'var(--light-gray)',
                    textDecoration: 'none',
                    fontSize: '0.875rem',
                    fontWeight: 300,
                    transition: 'color 300ms ease'
                  }}
                  className="footer-link"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.75rem',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              marginBottom: 'var(--space-l)',
              fontWeight: 500,
              color: 'var(--white)'
            }}>
              Контакты
            </h4>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--space-l)'
            }}>
              {[
                { href: 'https://t.me/natali_ro', icon: Send, label: 'Telegram' },
                { href: '#instagram', icon: Instagram, label: 'Instagram' }
              ].map((contact) => {
                const Icon = contact.icon;
                return (
                  <a 
                    key={contact.label}
                    href={contact.href} 
                    style={{
                      color: 'var(--light-gray)',
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 'var(--space-m)',
                      fontSize: '0.875rem',
                      fontWeight: 300,
                      transition: 'color 300ms ease'
                    }}
                    className="footer-link"
                  >
                    <Icon size={18} strokeWidth={1.5} />
                    <span>{contact.label}</span>
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{
          height: '1px',
          backgroundColor: 'var(--charcoal)',
          marginBottom: 'var(--space-xl)'
        }} />

        {/* Bottom Bar */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'var(--space-m)',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '0.75rem',
            color: 'var(--mid-gray)',
            fontFamily: 'var(--font-body)',
            letterSpacing: '1px',
            fontWeight: 300
          }}>
            © {currentYear} Наталья Ромашова. Все права защищены.
          </p>
          <p style={{
            fontSize: '0.75rem',
            color: 'var(--mid-gray)',
            fontFamily: 'var(--font-body)',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            fontWeight: 400
          }}>
            Санкт-Петербург
          </p>
        </div>
      </div>

      <style>{`
        .footer-link:hover {
          color: var(--accent-gold) !important;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
